export default function fixShopriteLogo(timeLimit=300) {
    const img = document.querySelectorAll('img[src*="/wp-content/themes/shoprite/img/logo-desktop.svg"]');
    if (img && img.length > 0) {
        img[0].src = 'http://www.shoprite.com/wp-content/themes/shoprite/img/logo-desktop.svg';
    } else if (timeLimit > 0) {
        setTimeout(() => fixShopriteLogo(timeLimit - 1), 1000);
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/fixShopriteLogo.js